var _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _use, _use2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _use3, _use4, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 392.33456 402.2681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "reuse-0",
    d: "m3892.12 3901.62-2562.65 44.08-62.78-2653.58 2580.93 8.41 44.5 2601.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-1",
    fill: "#0c171c",
    d: "M2126.21 2598.51c1.98-25.11 13.26-44.71 25.2-43.76 11.94.95 20 22.07 18.02 47.18-1.98 25.11-13.27 44.7-25.2 43.76-11.94-.95-20.01-22.07-18.02-47.18",
    clipPath: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reuse-2",
    fill: "#0c171c",
    d: "M1908.28 2588.39c1.99-25.11 13.27-44.7 25.21-43.76 11.93.95 20 22.07 18.02 47.18-1.98 25.12-13.27 44.71-25.2 43.76-11.94-.94-20.01-22.07-18.03-47.18",
    clipPath: "url(#k)"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2648.32 386.711h-5.39c.58.23 1.2.398 1.86.469.28.039.57.05.85.05.94 0 1.85-.179 2.68-.519",
    transform: "matrix(.07576 0 0 -.1087 -199.91363 42.402131)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aA",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aB",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aC",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aD",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aE",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aF",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aG",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aH",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aJ",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aK",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aL",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-0",
    transform: "translate(0 .000025)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m387.106185 28.233699-346.528-22.6990012-28.2389 374.5148222 349.3922 15.40026 25.3747-367.216081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "m375.069585 11.4229-359.5941-6.2550502-8.8094 376.5489002 362.1592-1.1934 6.2443-369.10045"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "m366.172585 22.882534-341.6866-5.87734-8.3707 353.810656 344.124-1.12134 5.9333-346.811976"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M2705.56 2631.8s-244.04 21.4-860.57-727.85l115.6-192.67s766.38 509.5 796.35 530.9c29.97 21.41-51.38 389.62-51.38 389.62",
    clipPath: "url(#b)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "m3082.26 3006.79-9.17-296.13-244.82-37.92 253.99 334.05",
    clipPath: "url(#c)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "M2681.3 2634.65s-49.24 166.98 2.14 179.82c51.38 12.84 383.19 81.35 421.72 42.82 38.54-38.54 25.69-137.01 25.69-137.01s321.1 16.62 496.65-139.15c151.99-134.86 353.93-728.56 285.43-822.75-68.5-94.19-565.15-166.98-565.15-166.98l-77.07 171.26s303.99 102.76 333.96 158.41c29.97 55.66-94.2 239.77-94.2 239.77s17.13-822.04-51.37-941.92c-68.51-119.88-890.55-64.23-890.55-64.23s-213.4 1198.8-171.25 1288.72c64.22 137.01 284 191.24 284 191.24",
    clipPath: "url(#d)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a79f",
    d: "M2000.9 2283.24v-152.91s-174.85 24.38-177.07 42.1c-2.21 17.73-8.85 195.03-8.85 195.03l185.92-84.22",
    clipPath: "url(#e)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M1820.95 2222.32c-2.71 58.2-5.97 145.14-5.97 145.14l185.92-84.22v-100.15c-57.19 21.25-119.38 28.57-179.95 39.23",
    clipPath: "url(#f)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M2008.41 2944.36s203.81-7.37 243.01-239.55c39.2-232.18 1.31-471.72-269.14-442.24-270.45 29.48-284.83 253.06-274.37 415.21 11.42 177.19 112.36 277.63 300.5 266.58",
    clipPath: "url(#g)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#bbbcaf",
    d: "M1801.09 2335.22c-2.07 1.86-4.09 3.75-6.08 5.66 1.99-1.91 4.01-3.8 6.08-5.66m-7.51 7.06c-88.42 86.73-92.78 225.3-85.67 335.51 1.25 19.39 3.57 37.86 6.96 55.37-3.39-17.5-5.71-35.99-6.96-55.38-7.11-110.2-2.75-248.77 85.67-335.5m-78.65 391.18c.01.04.02.09.02.12 0-.04-.01-.07-.02-.12",
    clipPath: "url(#h)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M2025.6 2260.12c-13.5 0-27.71.77-42.61 2.37-.24.03-.47.06-.71.08-48.86 5.33-89.36 16.99-122.87 33.48h-.01c-1.68.83-3.34 1.67-4.98 2.52-20.33 10.51-37.99 22.85-53.33 36.65-2.07 1.86-4.09 3.75-6.08 5.66-.48.47-.95.93-1.43 1.4-88.42 86.73-92.78 225.3-85.67 335.5 1.25 19.39 3.57 37.88 6.96 55.38l.06.3c.01.05.02.08.02.12 25.9 132.84 113.47 209.98 261.35 211.54-79.36-41.59-123.04-123.26-130.32-236.16-10.45-162.15 3.92-385.73 274.37-415.21 11.12-1.21 21.71-1.81 32.06-2.13-33.26-20.08-74.98-31.5-126.81-31.5",
    clipPath: "url(#i)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-1",
    clipPath: "url(#j)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-2",
    clipPath: "url(#k)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#864930",
    d: "M2201.95 2697.01s-7.72 2.91-19.29 7.28c-2.78.85-5.53 2.09-8.55 2.88-2.93 1.05-6.01 1.8-9.06 2.6-3.05.8-6.15 1.23-9.16 1.78-3.04.15-6.03.82-8.97.46-2.98.37-5.82-.45-8.76-.62-2.93-.31-5.73-1.5-8.73-1.92-2.85-1.02-5.67-2.22-8.57-3.12-2.84-1.04-5.38-2.64-8.02-3.73-2.64-1.12-5.21-2.17-7.26-3.46-2.07-1.24-4.13-2.18-5.79-3.01-3.37-1.63-5.62-2.46-5.62-2.46s.35 2.2 1.53 5.86c.6 1.82 1.3 4.11 2.39 6.56.91 2.6 2.37 5.26 4.34 7.98 1.97 2.7 3.93 5.89 6.76 8.66 2.98 2.62 6.15 5.53 9.87 8.03 4.06 2 8.17 4.63 12.95 5.79 4.78 1.24 9.73 2.38 14.79 2.16 5.08.21 9.94-.77 14.65-1.9 4.56-1.35 8.96-3.07 12.74-5.27 3.83-2.15 7.26-4.54 10.15-7.16 3.04-2.43 5.35-5.3 7.55-7.76 4.08-5.31 6.75-10.12 8.17-13.77 1.52-3.59 1.89-5.86 1.89-5.86",
    clipPath: "url(#l)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed9289",
    d: "M2063.87 2591.04s2.18-1.4 5.49-4.22c3.35-2.8 7.83-7.01 12.69-12.46 4.82-5.47 9.95-12.21 14.71-20 4.72-7.84 9.13-16.6 12.24-26.64 1.45-5.12 2.78-10.35 2.74-17.02.13-3.2-.92-7.85-1.93-10.25-1.4-3.9-2.94-6.17-4.8-8.64-3.6-4.74-7.73-7.94-11.65-10.45-3.94-2.5-7.79-4.28-11.4-5.63-14.47-5.19-24.72-4.29-24.72-4.29s1.82 1.68 5 4.62c3.12 2.88 7.56 6.84 12.26 11.62 4.64 4.68 9.86 10.47 12.24 15.91.55 1.18 1.05 2.93 1.01 3.34.39 1.89.13 1.81.04 3.22-.32 2.56-1.31 6.5-2.53 10.34-2.43 7.86-5.65 16.26-8.47 24.27-2.88 8.02-5.45 15.74-7.44 22.55-1.96 6.83-3.41 12.71-4.27 16.95-.89 4.21-1.21 6.78-1.21 6.78",
    clipPath: "url(#m)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a79f",
    d: "m1974.89 2154.15 114.54-18.28s-43.16-113.03-154.38-111.36c-111.22 1.66-184.25 139.61-184.25 139.61l99.59 26.6 124.5-36.57",
    clipPath: "url(#n)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M2089.66 2131.53s237.37-15.09 286.35-320.66l-90.43-26.41s97.96-192.4-37.68-256.53l22.61-377.26s-526.19 5.99-602.62-6.85c-15.32-2.58-158.46 893.4-158.46 893.4l110.52 71.68 156.99 3.77s143.17-132.04 312.72 18.86",
    clipPath: "url(#o)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M1569.09 1703.92c-1.81.26-3.62.57-5.43.83 42.26-254.68 95.24-562.44 104.23-560.93 76.43 12.84 602.62 6.85 602.62 6.85l-21.16 379.36c-137.48-25.68-462.87-38.53-680.26 173.89",
    clipPath: "url(#p)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#864930",
    d: "M2000.93 2695.62s-2.45.81-6.75 2.22c-4.15 1.43-10.08 3.21-16.75 5.34-3.42.92-7 2-10.79 2.88-3.71 1.12-7.69 1.76-11.64 2.68-3.99.7-8.07 1.35-12.14 1.84-4.09.19-8.18.92-12.25.57-4.1.33-8.09-.29-12.09-.65-4.07-.02-7.82-1.53-11.76-1.98-3.92-.61-7.47-2.28-11.18-3.13-3.77-.76-6.95-2.63-10.28-3.71-3.15-1.37-6.48-2.17-9.01-3.61-2.58-1.34-5.06-2.34-7.09-3.22-4.08-1.75-6.72-2.61-6.72-2.61s.91 2.44 3.06 6.46c1.09 2 2.4 4.51 4.16 7.19 1.56 2.89 4.04 5.48 6.79 8.36 2.83 2.77 5.52 6.43 9.53 8.84 3.9 2.5 7.84 5.76 12.66 7.71 2.39 1.06 4.88 2 7.4 2.98 2.5 1.12 5.14 1.84 7.89 2.25 5.44 1.22 11.05 2.02 16.69 1.83 5.68.2 11.19-.75 16.57-1.77 5.31-1.15 10.39-2.9 15.06-4.87 4.62-2.14 8.98-4.31 12.74-6.96 3.9-2.39 7.12-5.31 10.09-7.89 11.75-10.62 15.81-20.75 15.81-20.75",
    clipPath: "url(#q)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8080",
    d: "M1848.6 2911.73s32.66-103.93 169.25-92.05c136.59 11.87 151.44-2.97 190.04-74.24 38.6-71.26 59.38-145.49 47.51-249.42-11.88-103.93-83.14-234.58-243.49-237.55l-5.94-139.56s118.78 14.85 246.46-50.48c110.46-56.51 172.76 57.5 201.91 115.81 109.87 219.73-133.62 267.24-92.05 427.58 41.57 160.35 44.54 317.72-124.71 371.17-93.44 29.51-270.21 288.03-430.55 32.66-160.35-255.36 41.57-103.92 41.57-103.92",
    clipPath: "url(#r)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M1555.28 2063.79s-221.95-20.91-228.35-856.29l245.47-19.98s0 205.51 51.38 496.65-68.5 379.62-68.5 379.62",
    clipPath: "url(#s)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M2444.36 1916.53c-104.9 75.1-186.92 138.7-186.92 138.7s-272.48-21.2-45.67-265.45c80.61-86.82 187.61-152.05 282.86-198.09-16.89 104.31-34.49 216.77-50.27 324.84",
    clipPath: "url(#t)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-1",
    clipPath: "url(#u)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reuse-2",
    clipPath: "url(#v)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M2094.17 2693.69s.42 2.27 1.57 5.89c.59 1.79 1.25 4.03 2.24 6.38.78 2.42 2.18 5.06 4.24 7.88 1.99 2.75 4.13 6.09 6.99 8.87 2.98 2.62 6.15 5.54 9.87 8.04 4.04 2.01 8.16 4.61 12.93 5.8 4.78 1.24 9.73 2.39 14.79 2.18 5.08.21 9.94-.75 14.65-1.88 2.39-.45 4.49-1.52 6.65-2.35 2.13-.89 4.28-1.67 6.1-2.91 3.83-2.15 7.27-4.53 10.16-7.15 3.04-2.44 5.35-5.3 7.56-7.77 4.07-5.32 6.73-10.13 8.15-13.79 1.51-3.58 1.88-5.87 1.88-5.87s-7.72 2.9-19.31 7.25c-2.78.84-5.53 2.09-8.56 2.88-2.92 1.05-5.99 1.8-9.04 2.59-3.04.83-6.16 1.22-9.16 1.8-3.03.15-6.02.84-8.96.48-2.98.37-5.82-.43-8.77-.6-2.94-.28-5.73-1.51-8.74-1.91-2.85-1.02-5.67-2.22-8.57-3.11-2.81-1.03-5.18-2.48-7.79-3.52-2.55-1.02-5.18-2.09-7.36-3.56-2.17-1.34-4.27-2.33-5.95-3.18-3.39-1.69-5.57-2.44-5.57-2.44",
    clipPath: "url(#w)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M2063.87 2591.04s2.18-1.4 5.49-4.22c3.35-2.8 7.83-7.01 12.69-12.46 4.82-5.47 9.95-12.21 14.71-20 4.72-7.84 9.13-16.6 12.24-26.64 1.45-5.12 2.78-10.35 2.74-17.02.13-3.2-.92-7.85-1.93-10.25-1.4-3.9-2.94-6.17-4.8-8.64-3.6-4.74-7.73-7.94-11.65-10.45-3.94-2.5-7.79-4.28-11.4-5.63-14.47-5.19-24.72-4.29-24.72-4.29s1.82 1.68 5 4.62c3.12 2.88 7.56 6.84 12.26 11.62 4.64 4.68 9.86 10.47 12.24 15.91.55 1.18 1.05 2.93 1.01 3.34.39 1.89.13 1.81.04 3.22-.32 2.56-1.31 6.5-2.53 10.34-2.43 7.86-5.65 16.26-8.47 24.27-2.88 8.02-5.45 15.74-7.44 22.55-1.96 6.83-3.41 12.71-4.27 16.95-.89 4.21-1.21 6.78-1.21 6.78",
    clipPath: "url(#x)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M2000.93 2695.62s-2.45.81-6.75 2.22c-4.15 1.43-10.08 3.21-16.75 5.34-3.42.92-7 2-10.79 2.88-3.71 1.12-7.69 1.76-11.64 2.68-3.99.7-8.07 1.35-12.14 1.84-4.09.19-8.18.92-12.25.57-4.1.33-8.09-.29-12.09-.65-4.07-.02-7.82-1.53-11.76-1.98-3.92-.61-7.47-2.28-11.18-3.13-3.77-.76-6.95-2.63-10.28-3.71-3.15-1.37-6.48-2.17-9.01-3.61-2.58-1.34-5.06-2.34-7.09-3.22-4.08-1.75-6.72-2.61-6.72-2.61s.91 2.44 3.06 6.46c1.09 2 2.4 4.51 4.16 7.19 1.56 2.89 4.04 5.48 6.79 8.36 2.83 2.77 5.52 6.43 9.53 8.84 3.9 2.5 7.84 5.76 12.66 7.71 2.39 1.06 4.88 2 7.4 2.98 2.5 1.12 5.14 1.84 7.89 2.25 5.44 1.22 11.05 2.02 16.69 1.83 5.68.2 11.19-.75 16.57-1.77 5.31-1.15 10.39-2.9 15.06-4.87 4.62-2.14 8.98-4.31 12.74-6.96 3.9-2.39 7.12-5.31 10.09-7.89 11.75-10.62 15.81-20.75 15.81-20.75",
    clipPath: "url(#y)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M2450.68 1613.98c14.83-7.86 29.53-15.32 43.95-22.29-16.89 104.31-34.49 216.77-50.27 324.84-5.79 4.14-11.48 8.24-17.13 12.3l23.45-314.85",
    clipPath: "url(#z)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#f55",
    d: "M2257.11 2513.75c-.47-5.82-1.02-11.72-1.71-17.73-11.88-103.93-83.14-234.58-243.49-237.55l-5.94-139.56s81.01 10.08 181.12-23.17c184.11 100.37 144.03 318.62 70.02 418.01",
    clipPath: "url(#A)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "m3131.84 2717.85-1.09-.05s13.48 100.12-26.97 139.29c-40.45 39.18-388.79-30.47-442.72-43.53-53.94-13.06-2.25-182.82-2.25-182.82s-29.21-41.35 220.24-13.05c133.74 15.17 213.82 49.13 252.79 100.16",
    clipPath: "url(#B)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M2708.84 2608.66c-11.22.75-20.06 1.93-26.95 3.38-19.94 61-23.18 121.87-18.72 185.76 9.61-5.22 19.1-9.69 28.49-13.49 2.51-59.06 4.53-118.34 17.18-175.65",
    clipPath: "url(#C)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M2737.54 2607.8c-.81 0-1.62 0-2.41.01-13.09 54.49-15.52 111.16-17.7 167.62 6.94-1.98 13.87-3.65 20.8-5.03 3.77-54.13 5.73-108.41 9.88-162.51-3.66-.06-7.19-.09-10.57-.09",
    clipPath: "url(#D)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M2773.76 2608.75c-4.11 52.5-6.09 105.18-9.59 157.73 6.45-.68 12.92-1.16 19.43-1.46 4.16-51.67 9.56-103.24 12.9-154.97-8.02-.54-15.6-.97-22.74-1.3",
    clipPath: "url(#E)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M2922.12 2623.56c-2.75 51.58-10.88 102.63-17.85 153.79 8.05 2.86 16.29 6.28 24.62 10.22 6.13-53.27 8.48-107.02 14.29-160.36-6.85-1.28-13.85-2.5-21.06-3.65",
    clipPath: "url(#F)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M2968.43 2632.44c-6.01 55.89-8.31 112.21-15.2 167.96 11.45 6.65 22.91 14.19 34.13 22.5 2.34-23.82 1.32-48.29.74-71.65-.93-38.05-.79-76.1-.66-114.16-6.18-1.61-12.47-3.17-19.01-4.65",
    clipPath: "url(#G)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M3012.96 2644.43c-.05 38.67-.01 77.33.94 115.99.66 26.73 1.15 54.55-3.12 81.28 6.7 5.82 13.23 11.89 19.56 18.23 11.27-67.11 18.71-135.58 15.19-203.46-10.18-4.27-20.9-8.33-32.57-12.04",
    clipPath: "url(#H)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M3071.83 2668.92c2.08 66.72-5.69 133.96-16.91 199.71 6.96-.27 13.3-.78 19.08-1.51 3.9-63.53 11.55-126.7 11.6-190.11-4.4-2.77-8.95-5.48-13.77-8.09",
    clipPath: "url(#I)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#112739",
    d: "M3131.52 2717.43c.02.03.04.05.05.07-.01-.02-.03-.04-.05-.07m.13.17c.06.08.13.17.19.25-.06-.08-.12-.17-.19-.25m-.9.2 1.09.05-1.09-.05m-1.58 83.53c-3.88 21.43-11.42 42.23-25.39 55.76-.09.09-.19.19-.29.28.1-.1.2-.19.29-.28 13.97-13.53 21.51-34.33 25.39-55.76",
    clipPath: "url(#J)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M3110.97 2695.75c-1.27 54.69-7.16 109.26-10.84 164.07 1.26-.77 2.4-1.58 3.36-2.45.1-.09.2-.19.29-.28 13.97-13.53 21.51-34.33 25.39-55.76 7.36-40.63 1.58-83.53 1.58-83.53l1.09.05c-.06-.08-.13-.17-.19-.25-.02-.03-.05-.07-.08-.1-.01-.02-.03-.04-.05-.07-5.87-7.62-12.75-14.84-20.55-21.68",
    clipPath: "url(#K)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#112739",
    d: "M2879.05 2617.69c.15.01.3.03.45.05-.15-.02-.3-.04-.45-.05",
    clipPath: "url(#L)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M2870.33 2616.73c-2.58 50.21-8.07 100.26-12.34 150.35.7.06 1.4.11 2.1.17 6.15.48 12.58 1.45 19.23 2.9 6.86-49.98 14.68-99.85 17.38-150.25-5.67-.74-11.33-1.49-17.2-2.16-.15-.02-.3-.04-.45-.05-2.98-.34-5.83-.65-8.72-.96",
    clipPath: "url(#M)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M2821.99 2611.99c-3.32 50.95-8.75 101.75-12.91 152.63 7.84.11 15.76.39 23.79.81 4.38-50.41 9.87-100.76 12.23-151.32-8.02-.79-15.76-1.5-23.11-2.12",
    clipPath: "url(#N)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M3192.2 3312.29c-17.6 35.97-42.56 32.47-64.96 17.35 1.88 120.94-9.94 237.6-69.58 283.13-114.16 87.16-327.86 52.05-327.86 52.05s-86.29.02-131.04-22.36c-52.61-26.3-65.84-81.69-79.96-176.92-26.13-176.25-25.05-529.19 72.7-616.21 97.74-87.01 174.14-89.48 268.59-82.08 94.46 7.4 256.58 131.46 253.67 271.02-.25 12.23 0 26.13.57 41.24 88.7 23.07 116.65 153.54 77.87 232.78",
    clipPath: "url(#O)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#b1aea2",
    d: "M3057.26 3613.07c-.05.04-.08.07-.13.1.04-.03.09-.06.13-.1m-.41.31-.15.12.15-.12m-.41.31-.15.12.15-.12m-.42.32c-.05.04-.09.06-.14.1.05-.03.09-.07.14-.1m-.45.34-.09.06.09-.06m-.94.69c-.01.01-.01.01-.02.01.01 0 .01-.01.02-.01m-.43.31c-.01.01-.03.03-.05.04.02-.01.04-.03.05-.04m-.44.32c0 .01-.02.02-.03.03l.03-.03",
    clipPath: "url(#P)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M2802.83 2764.58c-25.85.01-50.87 2.17-76.03 8.36 55.53 5.83 108.75 24.71 151.04 64.45 79.4 74.6 108.09 187.68 114.47 293.11 7.55 124.69-25.7 247.11-40.71 369.99-6.63 54.33-13.64 109.55-24.85 163.67 45.33-7.67 90.79-22.23 126.98-48.46.01-.01.03-.02.03-.03.13-.1.26-.19.39-.28.02-.01.04-.03.05-.04.14-.1.27-.2.41-.3.01 0 .01 0 .02-.01.28-.21.56-.42.85-.63l.09-.06c.1-.08.21-.16.31-.24.05-.04.09-.06.14-.1.09-.07.18-.14.27-.2l.15-.12c.09-.06.18-.13.26-.19l.15-.12c.1-.07.19-.14.28-.21.05-.03.08-.06.13-.1.14-.1.27-.2.4-.3 55.86-42.64 69.76-147.67 69.76-260.17 0-7.62-.06-15.28-.18-22.96 9.62 6.49 19.72 10.84 29.5 10.84 12.99 0 25.42-7.67 35.46-28.19 11.44-23.37 17.07-51.19 17.05-79.41-.04-67.44-32.38-137.11-94.92-153.37-.42-11.09-.66-21.54-.67-31.15 0-3.48.04-6.84.1-10.09.03-1.23.04-2.46.04-3.68.01-65.29-35.8-126.99-83.46-174.66-6.33-6.34-12.86-12.41-19.56-18.23-7.63-6.63-15.47-12.91-23.42-18.8-11.22-8.31-22.68-15.85-34.13-22.5-8.14-4.73-16.29-9.02-24.34-12.83-8.33-3.94-16.57-7.36-24.62-10.22-15.66-5.57-30.62-9.04-44.18-10.1-19.76-1.55-38.72-2.67-57.26-2.67",
    clipPath: "url(#Q)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#312c2d",
    d: "M2565.46 3549.9c-65.33 26.18-114.1 100.72-112.48 172.6 0 0 64.02-48.21 108.41-29.87 0 0-63.8 38.68-44.37 116.83 86.558-16.0325 164.3558-9.2444 245.64 18.78 92.89 36.85 332.12 80.25 345.22-128.67 0 0 93.15 2.89 106.99-127.95 13.84-130.85-37.41-237.72-37.41-237.72s-57.44 16.81-70.84-53.6c-13.4-70.4-12.35-95-12.35-95l-49.19-2.12 2.2 139.75s-63.62 46.56-64.76 264.21c0 0-221.51-105.46-417.06-37.24",
    clipPath: "url(#R)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#211c1d",
    d: "M3214.87 3571.62c-13.84 130.85-106.99 127.95-106.99 127.95-6.65 106.13-71.68 147.08-146.22 156.92 25.74-111.15-11.65-229.56-91.37-308 67.23 17.28 112.23 38.65 112.23 38.65 1.14-217.65 64.76-264.21 64.76-264.21l-2.2-139.75 49.19 2.12s-1.05 24.6 12.35 95c13.4 70.41 70.84 53.6 70.84 53.6s51.25 106.87 37.41 237.72",
    clipPath: "url(#S)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M2734.83 3043.37s-4.1-4.63-13.3-10.57c-4.64-2.84-10.47-6.34-18.04-8.7-7.45-2.54-16.7-4.73-27.32-3.49-10.48.97-22.48 5-32.24 13.07-2.55 1.87-4.55 4.22-6.85 6.45l-3.37 3.44-2.79 3.77c-1.84 2.58-3.69 5.19-5.57 7.82-2.19 4.46-2.75 4.81-4.35 8.84-3.01 7.51-4.5 13.75-5.53 20.27-1.16 6.51-1.7 12.96-1.82 19.34-.44 12.81.58 25.42 2.07 37.81 1.75 12.35 3.97 24.48 6.78 36.22 2.67 11.78 6.03 23.11 9.45 33.98 6.94 21.72 14.82 41.4 22.54 57.86 7.49 16.53 14.82 29.84 20.21 39.01 5.38 9.18 8.96 14.19 8.96 14.19s-.79-6.09-2.55-16.52c-1.77-10.43-4.34-25.25-7.91-42.74-3.47-17.39-7.51-37.68-11.84-59.42-4.3-21.56-8.68-44.44-11.69-67.03-1.54-11.26-2.52-22.47-2.84-33.14-.12-5.34-.09-10.57.33-15.45.26-4.91 1.33-9.81 1.87-12.9.01-1.32 2.19-5.85 2.13-6.44 1.11-1.96 2.14-3.96 3.14-5.97l1.51-3.01 1.86-2.51c1.28-1.62 2.34-3.56 3.68-5 5.23-6.1 11.59-10.19 18.53-12.72 14.13-4.91 29.19-2.69 39.06-.77 10.07 2.16 15.89 4.31 15.89 4.31",
    clipPath: "url(#T)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c171c",
    d: "M2818.6 3304.22c1.28-24.18 11.83-43.27 23.56-42.64 11.73.63 20.2 20.73 18.91 44.91-1.28 24.18-11.83 43.27-23.56 42.64-11.73-.62-20.2-20.73-18.91-44.91",
    clipPath: "url(#U)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c171c",
    d: "M2600.96 3288.47c1.28-24.17 11.84-43.27 23.56-42.64 11.73.63 20.2 20.74 18.91 44.91-1.28 24.18-11.83 43.27-23.56 42.65-11.73-.63-20.2-20.74-18.91-44.92",
    clipPath: "url(#V)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#211c1d",
    d: "M2922.92 3413.37s-.93.27-2.67.78c-1.64.58-4.19 1.13-7.11 2.11-2.89 1-6.66 1.82-10.49 3.08-3.96 1.07-8.21 2.42-12.77 3.59-4.56 1.19-9.26 2.54-14.17 3.52-4.76 1.44-9.88 1.78-14.69 3.02-5 .18-9.82 1.65-14.66 1.46-2.41.12-4.81.22-7.18.46l-7.11-.37c-1.18-.01-2.37.14-3.56.08l-3.52-.59c-2.34-.44-4.75-.5-7.15-.68-4.7-1.16-9.52-2.12-14.46-2.92-4.72-1.71-9.59-3.04-14.48-4.22-4.75-1.61-9.28-3.56-13.83-4.98-2.33-.72-4.57-1.41-6.69-2.07-2.09-.85-4.08-1.66-5.94-2.42-3.78-1.55-7.41-2.68-10.39-3.71-6.01-2.01-10.03-2.9-10.03-2.9s.59 3.79 2.64 9.96c1.05 3.07 2.3 6.9 4.13 11.06.89 2.12 1.91 4.3 3.06 6.59 1.33 2.14 2.87 4.28 4.45 6.61 3.31 4.49 6.9 9.53 11.45 14.25 4.94 4.34 10.44 8.84 16.44 13.16 3.16 1.98 6.72 3.5 10.23 5.22 3.56 1.65 7.12 3.48 10.99 4.64 3.95.97 7.95 2.07 12.05 2.78l6.14 1.15c2.07.21 4.17.24 6.26.31l12.56-.15c4.12-.37 8.14-1.43 12.13-2.17l5.92-1.28 5.53-2.11c3.64-1.44 7.25-2.78 10.58-4.48 6.42-3.76 12.61-7.33 17.49-11.83 5.15-4.16 9.29-8.78 12.86-13.15 7.03-8.88 11.16-17.34 13.32-23.65 2.32-6.19 2.67-10.15 2.67-10.15",
    clipPath: "url(#W)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#211c1d",
    d: "M2670 3399.05s-.83.13-2.39.37c-1.44.3-3.71.45-6.25.96-2.51.38-5.56.84-9.05 1.37-3.41.42-6.97 1.1-10.78 1.52-3.76.51-7.63 1.02-11.55 1.3-3.82.67-7.81.33-11.51.86-3.78-.32-7.41.25-10.93-.24-3.53.04-6.93-.49-10.34-.88-3.47-.07-6.8-1.44-10.43-1.5-3.44-1.36-7.19-1.69-10.95-2.7-3.66-1.37-7.52-2.41-11.46-3.33-3.74-1.47-7.51-2.83-11.25-3.98-3.85-.99-7.39-2.23-10.53-3.5-3.19-1.18-6.33-2.02-8.88-2.8-5.17-1.53-8.71-2.16-8.71-2.16s-.04 3.35.93 8.79c.52 2.71 1.11 6.1 2.19 9.77.49 1.88 1.17 3.76 1.83 5.84.84 1.94 1.92 3.85 2.99 5.96 2.26 4.08 4.91 8.49 8.1 12.94 3.71 4.03 7.92 8.23 12.61 12.27 4.92 3.78 10.89 7 16.92 10.03 6.5 2.26 13.32 4.56 20.41 5.36l10.73.55c3.56.24 7.04-.74 10.5-1.11 6.99-.71 13.23-3.43 19.17-5.75 5.59-2.98 10.98-5.87 15.16-9.63 4.4-3.49 7.96-7.34 10.92-11.1 5.91-7.54 9.15-14.88 10.75-20.36 1.73-5.37 1.8-8.85 1.8-8.85",
    clipPath: "url(#X)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M3188.65 3272.59c-5.49 3.83-11.26 7.13-17.1 9.49-2.88 1.17-5.87 2.17-8.68 2.35-2.81.46-5.39.1-7.43-.75-2.08-.86-3.58-2.44-4.97-4.38-.83-.73-1.18-2.29-1.81-3.35-.64-1.08-1.14-2.34-1.43-3.81-.82-2.72-1.54-5.48-1.79-8.59-.54-3.09-.94-5.69-1.14-9.16-.6-6.59-.99-13.21-1.79-19.77-.68-6.56-1.63-13.22-1.81-19.59-.39-6.42-1.04-12.83-1.52-19.26-.02-6.24-.6-13.13-.54-18.87l-5.83 6.92c3.96-1.24 7.28-2.57 10.83-4.23 3.49-1.63 6.9-3.6 10.17-6.17 3.22-2.6 6.58-5.74 8.69-10.6.97-2.46 1.54-5.31 1.16-8.05-.34-2.72-1.37-5.1-2.59-7.06-2.49-3.93-5.63-6.46-8.74-8.65-3.16-2.19-6.45-3.8-9.74-5.34-6.6-2.99-13.42-5.04-20.3-6.7 5.89 3.93 11.71 7.84 17.09 12.02 2.66 2.1 5.25 4.28 7.4 6.64 2.23 2.23 4.16 4.73 4.96 6.99.89 2.36.37 3.57-.36 4.98-.94 1.46-2.95 3.16-5.37 4.58-2.46 1.41-5.31 2.61-8.21 3.75-2.87 1.09-6.14 2.08-8.9 2.7l-5.3 1.19-.54 5.73c-.35 3.71-.54 7.23-.54 10.57v10.24c.38 6.78.69 13.56 1.21 20.34.41 6.86 1.51 13.28 2.36 19.86.81 6.57 2.04 13.08 3.07 19.62.41 3.13 1.25 7.02 2.15 10.4.74 3.46 2.12 6.96 3.7 10.43.63 1.72 1.56 3.43 2.78 5.11 1.25 1.65 1.96 3.4 3.67 4.86 2.93 3.07 6.92 5.53 11.25 6.4 4.33.83 8.61.39 12.13-1 3.66-1.2 6.74-3.15 9.6-5.17 5.68-4.14 10.35-9.16 14.21-14.67",
    clipPath: "url(#Y)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M2543.92 1296.29c-18.3 106.68-44.38 261.91-69.79 424.05 70.18 7.39 140.2 16.47 210 27.93 20.55 3.37 41.07 6.96 61.54 10.75 3.56-8.09 8.23-15.18 14.12-20.62 25.25-23.31 135.62-44.86 221.2-44.86 40.19 0 74.91 4.76 92.78 16.32 42.46 27.47 49.95 98.67 32.03 138.98 5.05 1.6 10.1 3.21 15.14 4.84 6.71 2.16 13.42 4.36 20.11 6.58 1.02-15.33 2.67-26.86 5.16-32.34.52-1.14 1.07-2.02 1.66-2.62.76-.75 1.53-1.12 2.32-1.12.36 0 .73.08 1.09.22 5.4 2.17 11.53 20.09 17.36 45.24 59.36 20.58 117.89 43.51 175.66 68.18 57.06 24.37 110.75 55.72 167.86 79.68.27-46.01.33-100.31-.08-158.71-99.46-48.15-241.37-96.13-241.37-96.13l77.07-171.26s69.25 10.15 159.6 27.77c-4.31-123.65-12.02-241.56-25.44-319.83l-938.02-3.05",
    clipPath: "url(#Z)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c5353",
    d: "M3060.55 2383.35s36.23 123.68 167.76 86.82c131.54-36.86 144.04-177.61 113.68-293.84-30.37-116.23-32.87-147.67 4.96-169.15 0 0-125.1-113.95-165.49 73.85-40.4 187.79-120.91 302.32-120.91 302.32",
    clipPath: "url(#aa)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M3089.61 2458.82c34.03-2.33 59.78-31.22 57.5-64.53-2.28-33.31-31.71-58.42-65.74-56.1-34.04 2.33-59.79 31.21-57.51 64.52 2.28 33.32 31.71 58.43 65.75 56.11",
    clipPath: "url(#ab)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M2457.24 1187.52s-25.69 431 159.84 528.04c125.57 65.69 408.16 54.24 562.29-17.12 154.14-71.36 165.55-385.33 154.14-562.3-11.42-176.968-847.73-11.42-876.27 51.38",
    clipPath: "url(#ac)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M3285.28 1573.05c-42.57-97.34-119.18-179.97-217.22-218.86-190.29-75.47-405.19-63.13-603.15-28.39-2.08.37-4.08.93-6.13 1.36-5.09-79.95-1.54-139.64-1.54-139.64 28.54-62.8 864.85-228.348 876.27-51.38 7.87 121.99 4.87 309.07-48.23 436.91",
    clipPath: "url(#ad)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#ececec",
    d: "M2759.79 1738.4c-37.1 34.25-25.69 134.15 5.71 134.15 31.4 0 302.56 25.69 331.1-8.56 28.54-34.25 25.69-122.74-22.83-154.13-55.9-36.17-276.87-5.71-313.98 28.54",
    clipPath: "url(#ae)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M2773.52 1872.81c-3.42-.16-6.17-.26-8.02-.26-31.29 0-42.72-99.19-6.08-133.77-3.2 45.28 2.08 92.59 14.1 134.03",
    clipPath: "url(#af)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M2808.95 1874.93c-6.23-.39-12.02-.76-17.19-1.08-13.87-44.57-19.54-97.17-14.21-146.16 4.76-2.16 10.24-4.27 16.18-6.32 3.13 51.37 7.91 102.57 15.22 153.56",
    clipPath: "url(#ag)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M2839.66 1876.83c-4.54-.27-8.99-.54-13.25-.8-7.72-53.08-12.68-106.4-15.86-159.9 8.23-2.32 17.14-4.52 26.51-6.59.43 55.77 2.2 111.52 2.6 167.29",
    clipPath: "url(#ah)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M2869.58 1878.51c-4.36-.23-8.67-.46-12.89-.69-.35-57.26-2.23-114.5-2.65-171.76 3.62-.68 7.33-1.32 11.04-1.96-2.33 57.7 6.42 117.72 4.5 174.41",
    clipPath: "url(#ai)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M2913.07 1880.48c-8.94-.33-17.83-.71-26.54-1.12 1.62-57.86-7.91-119.4-4.71-177.96 13.2-1.96 26.74-3.59 40.26-4.87.93 61.45-2 122.8-9.01 183.95",
    clipPath: "url(#aj)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M2939.15 1695.12c2.95-.21 5.88-.38 8.81-.55 10.55 61.64 12.75 123.83 6.82 187.04-8.14-.13-16.35-.31-24.57-.55 7-61.82 9.92-123.84 8.94-185.94",
    clipPath: "url(#ak)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M2981.53 1881.78c-3.18.01-6.38.02-9.61.01 5.77-63.52 3.44-125.98-6.98-187.95 10.31-.3 20.35-.31 29.99-.03 1.91 63.21 4.2 126.56-13.4 187.97",
    clipPath: "url(#al)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M3038.45 1697.89c8.95 59.93 4.94 122.1-2.67 181.97-11.29.87-23.59 1.42-36.58 1.7 16.24-61.41 14.47-124 12.73-186.9 9.5.7 18.38 1.77 26.52 3.23",
    clipPath: "url(#am)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "m3056.16 1702.08.89.33c18.66 54.72 21.93 113.26 17.45 171.99-6.17 1.49-13.31 2.73-21.26 3.73 7.18-58.03 10.63-117.94 2.92-176.05",
    clipPath: "url(#an)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M3096.6 1863.99c-1.1 1.32-2.68 2.53-4.48 3.68 3.32-52.85.11-104.97-14.12-154.59 44.3 33.75 46.26 117.72 18.6 150.91",
    clipPath: "url(#ao)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M3239.19 2110.7c-18.68 9.6-36.18-3.81-46.92-15.57-.32 83.75-22.82 163.5-48.7 205.14-72.45 116.52-335.52 190.24-466.78-33.97 0 0-200.39-429.63 192.42-463.6 187.07-16.17 274.57 69.49 307.13 176.24 88.89-.23 92.36 116.61 62.85 131.76",
    clipPath: "url(#ap)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "M3247.26 2112.69c-18.68 9.6-36.18-3.81-46.92-15.57-.32 83.76-22.82 163.5-48.7 205.14-72.45 116.52-335.52 190.24-466.78-33.96 0 0-200.39-429.64 192.42-463.6 187.06-16.18 274.57 69.49 307.13 176.23 88.89-.23 92.36 116.61 62.85 131.76",
    clipPath: "url(#aq)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c171c",
    d: "M2783.06 2071.98c-3.52-22.02-14.85-38.52-25.32-36.84-10.46 1.67-16.1 20.88-12.58 42.9 3.52 22.02 14.85 38.51 25.32 36.84 10.47-1.68 16.1-20.88 12.58-42.9",
    clipPath: "url(#ar)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#0c171c",
    d: "M3008.91 2047.62c-3.52-22.02-14.85-38.52-25.32-36.84-10.47 1.67-16.1 20.88-12.58 42.9 3.52 22.02 14.85 38.51 25.32 36.83 10.46-1.67 16.1-20.88 12.58-42.89",
    clipPath: "url(#as)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M2862.23 2078.8s-1.96-8.86-6.56-20.51c-2.14-5.93-5.01-12.53-8.09-19.41-3.06-6.87-6.49-14.06-9.19-20.82-1.35-3.3-2.5-6.71-2.96-8.94-.18-1.25-.4-1.16-.19-2.85-.06-.36.26-1.94.66-3.02 1.72-4.96 5.91-10.44 9.64-14.94 3.88-4.47 7.48-8.33 10.03-11.08 2.61-2.81 4.09-4.42 4.09-4.42s-2.26.01-6.1.66c-3.82.7-9.24 2-15.38 4.91-3.06 1.46-6.41 3.21-9.69 5.72-3.29 2.49-6.7 5.6-9.54 10.04-1.47 2.32-2.67 4.43-3.63 7.96-.72 2.19-1.32 6.37-.98 9.18.43 5.89 1.97 10.42 3.61 14.83 3.45 8.64 7.96 16.06 12.68 22.64 4.76 6.53 9.71 12.16 14.44 16.58 9.18 9.06 17.16 13.47 17.16 13.47",
    clipPath: "url(#at)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c5353",
    d: "M2934.08 2140.9s1.01 2.16 3.51 5.37c2.44 3.28 6.39 7.51 11.88 11.88 5.52 4.26 12.68 8.48 21.21 11.43 4.26 1.42 8.86 2.6 13.63 3.25 4.82.51 9.75.97 14.75.39 4.99-.23 9.88-1.34 14.6-2.79 2.4-.55 4.68-1.38 6.8-2.54 2.16-1.04 4.29-2.05 6.32-3.15 4.12-2.06 7.36-5.21 10.63-7.69 3.35-2.44 5.52-5.79 7.83-8.43 2.18-2.79 4.18-5.25 5.36-7.91 1.36-2.48 2.34-4.79 3.16-6.63 1.61-3.7 2.25-5.91 2.25-5.91s-2.27.94-5.75 2.77c-1.73.92-3.84 1.98-6.03 3.34-2.12 1.45-5 2.4-7.73 3.78-2.85 1.19-5.48 3.12-8.78 4.04-3.21 1.01-6.22 2.73-9.63 3.55-3.45.67-6.65 2.27-10.24 2.58-3.51.59-6.99 1.42-10.63 1.41-3.56.61-7.22.24-10.85.37-3.62-.15-7.26-.43-10.84-.77-7.14-.84-14.04-2.12-20.15-3.39-6.1-1.29-11.41-2.53-15.19-3.48-3.89-.94-6.11-1.47-6.11-1.47",
    clipPath: "url(#au)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M2913.29 1800.73c-14.03 0-28.74.65-44.08 1.97l-1.4.15c4.13.48 8.2 1.02 12.19 1.62 14.37-1.17 28.16-1.74 41.36-1.74 31.16 0 59.13 3.16 84.19 8.99-3.69-.97-7.46-1.88-11.29-2.73-6.26-1.38-12.69-2.6-19.31-3.65-5.55-.88-11.2-1.64-17.01-2.27-6.8-.74-13.79-1.31-20.96-1.7-7.68-.42-15.58-.64-23.69-.64",
    clipPath: "url(#av)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#f89d92",
    d: "M3186.95 1979.49c.05.5.11.98.17 1.47 5.08.12 9.89.64 14.4 1.51-4.53-1.39-9.38-2.4-14.57-2.98m20.83 124.89c3.32 3.92 6.54 6.48 8.99 8.09 2.01.64 4.08 1.1 6.19 1.33-5.56-2.11-10.69-5.57-15.18-9.42",
    clipPath: "url(#aw)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M2921.36 1802.73c-13.2 0-26.99.57-41.36 1.74 178.44 26.87 225.57 177.56 219.42 310.68 25.77-17.24 46.17-20.71 46.19-20.72-.03-.4-5.96-101.51-5.97-179.88 0-4.15.02-8.22.06-12.23-29.27-41.64-72.52-74.45-134.15-90.6-25.06-5.83-53.03-8.99-84.19-8.99m265.76 178.23c3.07 26.16 4.95 49.73 4.95 65.01 0 .89-.01 1.74-.02 2.57-.01.76-.02 1.51-.02 2.25-.01 28.27 8.1 44.54 15.75 53.59 4.49 3.85 9.62 7.31 15.18 9.42 1.02.12 2.06.18 3.1.18 4.26 0 8.66-.98 13.13-3.28 26.42-13.56 26.42-108.64-37.67-128.23-4.51-.87-9.32-1.39-14.4-1.51",
    clipPath: "url(#ax)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#ac9393",
    d: "M3000.83 2295.83s-128.97-195.38-352.09-182.86c0 0 2.47-266.51-13.04-262.64-15.51 3.88-72.67 179.83-36.87 364.18 35.79 184.36 240.76 307.76 402.27 250.05 161.52-57.71 261.63-157.98 219.96-349.78 0 0-29.86-10.8-29.01-66.24.85-55.44-27.09-240.42-44.18-223.24-17.08 17.19-2.26 269.13-2.26 269.13s-117.07 19.89-144.78 201.4",
    clipPath: "url(#ay)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#293232",
    d: "M3168.64 1869.64c7.18 30.96 13.92 72.88 18.31 109.85-4.39-36.97-11.13-78.89-18.31-109.85",
    clipPath: "url(#az)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c2d2a",
    d: "M3151.28 1824.4c5.4 2.18 11.53 20.09 17.36 45.24-5.83-25.15-11.96-43.07-17.36-45.24",
    clipPath: "url(#aA)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#b66e5b",
    d: "M3186.95 1979.49c.05.49.11.99.17 1.47-.06-.49-.12-.97-.17-1.47",
    clipPath: "url(#aB)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#b66e5b",
    d: "M3187.12 1980.96c3.07 26.16 4.95 49.73 4.95 65.01 0-15.28-1.88-38.85-4.95-65.01",
    clipPath: "url(#aC)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#b66e5b",
    d: "M3139.64 1914.55c.01 78.37 5.94 179.48 5.97 179.88 0 0-5.96-101.36-5.97-179.88",
    clipPath: "url(#aD)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#713b26",
    d: "M3216.77 2112.47c2.58 1.7 4.29 2.31 4.29 2.31.04.18.08.35.11.52-.03-.17-.07-.34-.11-.52 0 0-1.71-.61-4.29-2.31",
    clipPath: "url(#aE)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#713b26",
    d: "M3221.21 2115.46c.03.13.05.23.08.36-.03-.11-.06-.24-.08-.36m.12.56c.02.11.05.22.07.34-.02-.11-.05-.24-.07-.34m.11.52c.02.11.05.24.08.35-.03-.11-.06-.24-.08-.35m.11.53c.04.16.07.34.11.5-.04-.16-.07-.34-.11-.5m.14.63c.02.13.05.25.08.38-.03-.13-.06-.25-.08-.38m.12.58c.02.11.04.22.07.32-.03-.1-.05-.21-.07-.32m.11.54c.02.09.04.19.06.28-.02-.09-.04-.19-.06-.28m.11.52c.02.1.04.2.06.31-.02-.11-.04-.2-.06-.31m.1.51c.04.16.07.32.1.48-.03-.16-.06-.32-.1-.48m.15.71c.02.1.04.18.06.28-.02-.09-.04-.19-.06-.28m.11.54c.02.08.03.16.05.24-.02-.09-.03-.16-.05-.24m.1.51c.02.07.04.17.05.24-.02-.08-.03-.15-.05-.24m.1.5c.02.07.04.16.05.23-.02-.08-.03-.15-.05-.23m.18.86c0 .03.01.06.02.1-.01-.03-.02-.07-.02-.1m.09.46c0 .03.01.09.02.12-.01-.04-.02-.08-.02-.12m.09.48c.01.05.02.09.03.13-.01-.04-.02-.09-.03-.13m.1.5c0 .02.01.04.01.06 0-.03 0-.03-.01-.06m.35 1.82c0 .01 0 .01.01.03-.01-.01-.01-.02-.01-.03m.09.47v.01-.01",
    clipPath: "url(#aF)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c5353",
    d: "M3150.19 1824.18c-.79 0-1.56.37-2.32 1.12-.59.6-1.14 1.48-1.66 2.62-4.94 10.88-6.57 45.64-6.57 86.63.01 78.52 5.97 179.88 5.97 179.88v.01s-71.35 12.12-115.83 103.8c19.88 16.88 38.07 35.82 51.24 61.21 28.25 54.46 20.36 115.17-.76 170.35 110.3-59.6 171.95-152.16 143.23-303.09v-.01c-.03-.15-.05-.29-.08-.44-.01-.02-.01-.02-.01-.03-.11-.58-.22-1.18-.34-1.76 0-.02-.01-.04-.01-.06-.02-.12-.05-.24-.07-.37-.01-.04-.02-.08-.03-.13-.02-.12-.04-.24-.07-.36-.01-.03-.02-.09-.02-.12-.03-.13-.05-.24-.07-.36-.01-.04-.02-.07-.02-.1-.05-.21-.09-.42-.13-.63-.01-.07-.03-.16-.05-.23-.01-.08-.03-.17-.05-.26-.01-.07-.03-.17-.05-.24-.01-.08-.03-.19-.05-.27-.02-.08-.03-.16-.05-.24-.02-.09-.04-.18-.05-.26-.02-.1-.04-.18-.06-.28-.01-.07-.03-.15-.05-.23-.03-.16-.06-.32-.1-.48-.01-.06-.02-.14-.04-.2-.02-.11-.04-.21-.06-.31-.02-.08-.03-.16-.05-.24-.02-.09-.04-.19-.06-.28-.02-.08-.03-.14-.04-.22-.03-.1-.05-.21-.07-.32-.02-.06-.03-.13-.04-.2-.03-.13-.06-.25-.08-.38-.01-.05-.02-.08-.03-.13-.04-.16-.07-.34-.11-.5l-.03-.18c-.03-.11-.06-.24-.08-.35-.01-.07-.02-.12-.04-.18-.02-.12-.05-.23-.07-.34-.02-.07-.03-.13-.04-.2-.03-.13-.05-.23-.08-.36-.01-.05-.02-.1-.04-.16-.03-.17-.07-.34-.11-.52 0 0-1.71-.61-4.29-2.31-8.09-5.31-24.76-21.16-24.74-61.68 0-.74.01-1.49.02-2.25.01-.83.02-1.68.02-2.57 0-15.28-1.88-38.85-4.95-65.01-.06-.48-.12-.98-.17-1.47-4.39-36.97-11.13-78.89-18.31-109.85-5.83-25.15-11.96-43.06-17.36-45.24-.36-.14-.73-.22-1.09-.22",
    clipPath: "url(#aG)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c5353",
    d: "M2723.16 2164.22s.48 1.98 2.07 5.04c1.52 3.12 4.21 7.18 8.18 11.58 4.13 4.17 9.53 8.75 16.68 11.92 3.48 1.67 7.49 2.88 11.61 3.75 4.23.66 8.59 1.19 13.06.64 4.48-.16 8.77-1.51 12.9-2.94 4.14-1.37 7.58-3.98 11.01-6.02 3.11-2.47 5.71-5.26 8.15-7.78 2.3-2.65 3.81-5.6 5.36-8.12 3.18-5.02 4-10.07 4.91-13.3.78-3.32.93-5.28.93-5.28s-1.92.89-4.77 2.57c-1.42.85-3.17 1.82-4.91 3.06-1.72 1.28-3.91 2.39-6.15 3.57-2.26 1.14-4.39 2.73-6.82 3.85-2.5 1-4.9 2.25-7.34 3.35-2.62.59-5.01 1.83-7.57 2.31-2.59.36-5.03 1.29-7.69 1.17-2.57.52-5.25.14-7.94.22-2.7-.27-5.47-.43-8.21-.93-2.75-.48-5.52-.93-8.18-1.65-2.72-.48-5.24-1.39-7.75-1.94-10.52-3.04-17.53-5.07-17.53-5.07",
    clipPath: "url(#aH)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M2154.68 2103.75c-74.21 28.54-131.3 28.54-131.3 28.54l5.71 97.05-216.93 28.54-59.94-174.11s176.97-122.74 313.98-54.23c137 68.5 88.48 74.21 88.48 74.21",
    clipPath: "url(#aI)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8080",
    d: "M1860.47 2923.6s74.24-148.46-65.32-267.24c-75.31-64.09 0-213.79 56.42-273.18 56.41-59.38 85.67-198.57-29.7-308.81-133.62-127.68-397.89 0-397.89 160.35 0 160.34 124.71 121.74 77.2 282.08-47.51 160.35 83.14 145.5 89.08 291 5.94 145.5 130.65 237.55 198.95 234.58 68.29-2.97 71.26-118.78 71.26-118.78",
    clipPath: "url(#aJ)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#f55",
    d: "M1843.56 2377.76c-1.52 1.61-3.07 3.31-4.62 5.05 5.4-58.54-13.04-126.8-75.3-186.3-92.46-88.35-250-49.49-331 36.72 2-153.27 254.45-274.56 382.38-152.31 110.9 105.97 82.77 239.76 28.54 296.84",
    clipPath: "url(#aK)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M3270.71 1762.66s-174.11 29.97-211.22-35.68c-37.1-65.65-85.62-194.09 31.4-28.54 0 0-128.44-305.41 45.67-22.84 0 0-99.9-299.7 51.38-34.25 0 0-99.9-239.76 48.52-34.25 0 0 45.67 0 97.05 19.98l-62.8 135.58",
    clipPath: "url(#aL)",
    transform: "matrix(.13333 0 0 -.13333 -161.322215 543.31857)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m60.758685 17.478057 114.4686 3.004645s-42.2843 62.424183-30.2462 87.733268c12.0381 25.3091 19.8903 4.00298 36.7392 6.82625 16.8489 2.82327 34.2914 254.85328 34.2914 254.85328l-30.6282.30751s-19.8462-210.79298-58.5991-207.03742c-38.753 3.75555-87.7463 8.46749-87.8318-48.96996-.086-57.437448 21.8061-96.717583 21.8061-96.717583z",
    opacity: 0.53
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.7ff3399091a927511d32670fb1c0f5c4.svg";
export { ForwardRef as ReactComponent };